import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import Switch from "@mui/material/Switch";
import React from "react";
import useDebugInformation from "../../hooks/useDebugInformation";
import { ui } from "../../interfaces/interfaces";
import useCharges from '../../hooks/useCharges';
import { Paper } from "@mui/material";
import { useAppSelector } from "@store/hooks";
import { AddressPrefix } from "@utils/BasicTypes";

const name = "BusinessSwitch"

type Props = {
  prefix: AddressPrefix
  parent: string
}

const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean, prefix: Props["prefix"]) => ui[`${prefix}IsBusiness`] = checked;

const BusinessSwitch: React.FC<Props> = ({ prefix, parent }) => {
  const asProperty = useAppSelector(({ ui }) => ui[`${prefix}AsProperty`])
  const isBusiness = useAppSelector(({ ui }) => ui[`${prefix}IsBusiness`])

  useCharges()
  const debugName = `[${parent}]▷[${name}]`

  useDebugInformation(debugName, { prefix, parent, isBusiness, asProperty })
  return (
    <Paper elevation={1} sx={{ p: .5, borderRadius: ".5rem", position: "relative", mr: 1 }}>
      <FormGroup row sx={{ mb: 0, pb: 0 }}>
        <FormControlLabel
          control={<Switch disabled={asProperty} checked={isBusiness} onChange={React.useCallback((event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => handleSwitchChange(event, checked, prefix), [prefix])} name={`IsBusiness`} color="primary" />}
          label="Business"
          style={{ zIndex: 9999 }} sx={{ mb: 0, ml: 0 }}
        />
      </FormGroup>
    </Paper>
  );
}

export default React.memo(BusinessSwitch)